import { townshipModelData } from './models/TownshipsModel'
import { AdminTownshipService } from './api/AdminTownshipService'

const TownshipModule = {
  namespaced: true,
  state: townshipModelData(),
  getters: {
    fetchTownshipList: state => state.townshipList,
    fetchPaginatedTownshipList: state => state.paginatedTownshipList,
    fetchQueryParams: state => state.queryParams,
    fetchEditDialog: state => state.editDialog,
    fetchFIPSList: state => state.FIPSList
  },
  mutations: {
    setTownshipList (state, data) {
      state.townshipList = data.list
    },
    setPaginatedTownshipList (state, data) {
      state.paginatedTownshipList = data.list
    },
    setEditDialog (state, data) {
      state.editDialog = data
    },
    addQueryParams (state, queryParams) {
      state.queryParams = queryParams
    },
    setFIPSList (state, data) {
      state.FIPSList = data.list
    }
  },
  actions: {
    /**
     * Get township list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getTownshipList ({ commit }, { resolve, reject, fetchOnlyPublished }) {
      try {
        const response = await AdminTownshipService.fetchTownshipList(fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getTownshipByStateAndCounty ({ commit }, { resolve, reject, countryId, stateId, countyId, fetchOnlyPublished }) {
      try {
        const response = await AdminTownshipService.fetchTownshipByStateAndCounty(countryId, stateId, countyId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get township list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getPaginatedTownshipList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminTownshipService.fetchPaginatedTownshipList(queryParams)
        const { success, data } = response.data
        if (success) {
          commit('setPaginatedTownshipList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setPaginatedTownshipList', {
            list: data.list
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get FIPS list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param formData | object
     */
    async getFIPSList ({ commit }, { resolve, reject }) {
      try {
        const response = await AdminTownshipService.fetchFIPSList()
        const { success, data } = response.data
        if (success) {
          commit('setFIPSList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getFilteredTownshipList ({ commit }, { resolve, reject, countryId, stateId, countyId, fetchOnlyPublished }) {
      try {
        const response = await AdminTownshipService.fetchFilteredTownshipList(countryId, stateId, countyId, fetchOnlyPublished)
        const { success, data } = response.data
        if (success) {
          commit('setTownshipList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addTownshipItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminTownshipService.addTownshipItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getPaginatedTownshipList', { resolve, reject })
          dispatch('getTownshipList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async editTownshipItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminTownshipService.editTownshipItem(editedData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getTownshipgetMapPostalCode ({ dispatch }, { resolve, reject, id = '' }) {
      try {
        const response = await AdminTownshipService.fetchTownshipPostalCode(id)
        const { success, data } = response.data
        if (success) {
          dispatch('getTownshipList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getTownshipDetailsById ({ dispatch }, { resolve, reject, idToGetInfo }) {
      try {
        const response = await AdminTownshipService.getTownshipDetailsById(idToGetInfo)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async validateTownshipItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminTownshipService.validateTownshipItem(formData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteTownshipItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminTownshipService.deleteTownshipItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getPaginatedTownshipList', { resolve, reject })
          dispatch('getTownshipList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }

}
export default TownshipModule
